import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { OrderAPI } from '@app/data/mo-api/order.api';
import { Observable, interval, of } from 'rxjs';
import { EORDER_STATUS } from '../enums/order.enum';
import { APP_CONSTANTS as CONST } from '@app/app.constants';
import { IGetOrder } from '../models/order.model';
import { filter, map, mergeMap, tap } from 'rxjs/operators';
import { OrderService } from '@app/domain/services/order/order.service';
import { StorageService } from '@app/data/browser/storage.service';

@Injectable({
  providedIn: 'root',
})
export class OrderGuard implements CanActivate {
  constructor(
    private _orderAPI: OrderAPI,
    private _route: ActivatedRoute,
    private _orderService: OrderService,
    private _storageService: StorageService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const transactionToken = route.queryParamMap.get('tx');
    return this._handleOrderInformation(transactionToken);
  }

  private _handleOrderInformation(token: string): Observable<boolean> {
    if (!!token) {
      return interval(CONST.ORDER_TIME_POLL).pipe(
        mergeMap(() => this._orderAPI.getOrderInformation(token)),
        tap((orderInformation: IGetOrder) => this._orderService.setOrderInfo(orderInformation)),
        filter(({ status }) => status !== EORDER_STATUS.PENDING),
        map(() => true)
      );
    } else {
      return of(false);
    }
  }
}
